<template>
  <div
    class="tool-tip calculator__disclosure"
    v-if="message.length !== 0"
    :class="{ '--is-active': showTooltip }"
  >
    <span
      class="tool-tip__icon +text-center"
      :id="tooltipIconId"
      v-on:click.prevent.stop="toggleTooltip"
      >i</span
    >
    <div
      class="tool-tip__box --right"
      v-if="showTooltip"
      v-on:click.prevent.stop="toggleTooltip"
    >
      <div class="tool-tip__arrow"></div>
      <template>
        <h4 v-if="messageTitle">{{ messageTitle }}</h4>
        <p>{{ message }}</p>
      </template>
    </div>
  </div>
</template>
<script>
import utils from '../../../bankrate-utilities'
import calculatorEventBus from 'apps/bankrate-calculators/events'

export default {
  data: function() {
    return {
      showTooltip: false
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    messageTitle: {
      type: String,
      default: ''
    },
    trackingEnabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    tooltipIconId: function() {
      const title = this.$parent.trackingName || this.title
      return utils.spacesFormat(title) + 'TT'
    }
  },
  methods: {
    toggleTooltip() {
      const open = this.showTooltip
      calculatorEventBus.$emit('tooltips:close')
      this.showTooltip = !open
      const title = this.$parent.trackingName || this.title
      if (this.showTooltip && this.trackingEnabled) {
        this.$store.dispatch('trackClick', {
          event,
          text: (title + ' info icon').toLowerCase()
        })
      }
    },
    closeTooltip() {
      this.showTooltip = false
    }
  },
  created() {
    calculatorEventBus.$on('tooltips:close', this.closeTooltip)
  }
}
</script>
